export default __webpack_public_path__ + "static/media/activity3.cd033096.jpg";